import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {toFixedPrice} from "../jobEditPopup/jobPricingFunctions";
import {getParsedJobOrder, getReferralAmount} from "./jobOrderFunctions";


const JobPurchaseOrderPopupHeader = (props) => {

  const {closePopup, job, jobTotal} = props;

  const jobOrder = getParsedJobOrder(job); // jobOrderInterface

  return (
    <div className={"job-payment__header job-payment__container flex flex--center flex--between relative"}>
      <div className="flex flex--center flex--end flex-item text-uppercase">
        {jobOrder && jobOrder.referralPercent ? (
          <div className="mr-2">
            <div className="bold font--11 line--11">
              Referral %
            </div>
            <div className="font--21">{jobOrder.referralPercent}%</div>
          </div>
        ) : null}
        {jobOrder && jobOrder.referralPercent ? (
          <div className="mr-2">
            <div className="bold font--11 line--11">
              Referral amount
            </div>
            <div className="font--21">
              ${toFixedPrice(getReferralAmount(jobOrder, jobTotal))}
            </div>
          </div>
        ) : null}
        <div className="">
          <div className="bold font--11 line--11">
            <FormattedMessage id="paymentPopup.total"/>
          </div>
          <div className="font--21">${toFixedPrice(jobTotal.totalWithTaxes)}</div>
        </div>
      </div>
      <button className="ui-popup-header__close ui-popup-header__close--small assign-filters__filter-close"
              onClick={closePopup}/>
    </div>
  )
};

JobPurchaseOrderPopupHeader.propTypes = {
  closePopup: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {job, jobTotal} = store.jobEditPopupState;
  return {
    jobTotal,
    job,
  };
};

export default (
  connect(mapStateToProps)(JobPurchaseOrderPopupHeader)
)
